import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lc-table-skeleton',
  templateUrl: './lc-table-skeleton.component.html',
  styleUrls: ['./lc-table-skeleton.component.scss'],
  host: { style: 'display: contents' },
})
export class LcTableSkeletonComponent {
  @Input() cols = 5;
  @Input() rows = 8;

  get rowList(): number[] {
    return Array.from({ length: Math.max(1, this.rows) }, (_, i) => i);
  }

  get colList(): number[] {
    return Array.from({ length: Math.max(1, this.cols) }, (_, i) => i);
  }

  lineWidth(colIndex: number): number {
    const widths = [92, 78, 88, 65, 72, 84, 70];
    return widths[colIndex % widths.length];
  }
}
